var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basicLayout',[(_vm.product.id)?_c('OrderLines',{attrs:{"product":_vm.product,"filter":"product","parent_can_supply_filter":_vm.can_supply_filter,"origin":"OrdersByProduct"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }